import * as React from 'react'
import { EditorUtils } from '@progress/kendo-react-editor'
import { DropDownList } from '@progress/kendo-react-dropdowns'
// import { Button } from '@progress/kendo-react-buttons'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import Settings from '@material-ui/icons/Settings'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { toggleDefaultValuesModal, paste } from 'actions/template'

export const mergeFields = [
  {
    text: `Contact's first name`,
    value: '{{ Contact.first_name }}',
    id: 1,
  },
  {
    text: `Contact's middle name`,
    value: '{{ Contact.middle_name }}',
    id: 2,
  },
  {
    text: `Contact's last name`,
    value: '{{ Contact.last_name }}',
    id: 3,
  },
  {
    text: `Contact's phone number`,
    value: '{{ Contact.phone }}',
    id: 4,
  },
  {
    text: `Contact's email address`,
    value: '{{ Contact.email }}',
    id: 5,
  },
  {
    text: `Contact's location`,
    value: '{{ Contact.location }}',
    id: 6,
  },
]

export const userMergeFields = [
  { text: `User's username`, id: 7, value: '{{ AssignedUser.user_name }}' },
  { text: `User's first name`, id: 8, value: '{{ AssignedUser.first_name }}' },
  { text: `User's last name`, id: 9, value: '{{ AssignedUser.last_name }}' },
  { text: `User's email address`, id: 10, value: '{{ AssignedUser.email }}' },
  {
    text: `User's phone number`,
    id: 11,
    value: '{{ AssignedUser.phone_number }}',
  },
  { text: 'Account ID', id: 12, value: '{{ Account.id }}' },
  { text: 'Account name', id: 13, value: '{{ Account.name }}' },
  { text: 'Business name', id: 14, value: '{{ Account.business_name }}' },
  { text: 'Mailing address', id: 15, value: '{{ Account.mailing }}' },
  {
    text: 'Default from email',
    id: 16,
    value: '{{ AccountPreference.default_email_from }}',
  },
  {
    text: 'Color logo URL',
    id: 17,
    value: '{{ AccountPreference.company_logo_url_color }}',
  },
  {
    text: 'Black logo on light background URL',
    id: 18,
    value: '{{ AccountPreference.company_logo_url_blackonwhite }}',
  },
  {
    text: 'White logo on dark background URL',
    id: 19,
    value: '{{ AccountPreference.company_logo_url_whiteonblack }}',
  },
  {
    text: 'Email footer logo URL',
    id: 20,
    value: '{{ AccountPreference.company_logo_url_email_footer }}',
  },
  {
    text: 'Default foreground color',
    id: 21,
    value: '{{ AccountPreference.email_color_foreground }}',
  },
  {
    text: 'Default background color',
    id: 22,
    value: '{{ AccountPreference.email_color_background }}',
  },
  {
    text: 'Default body Background color',
    id: 23,
    value: '{{ AccountPreference.email_color_body_background }}',
  },
  {
    text: 'Default header text color',
    id: 24,
    value: '{{ AccountPreference.email_color_text_header }}',
  },
  {
    text: 'Default paragraph text color',
    id: 25,
    value: '{{ AccountPreference.email_color_text_paragraph }}',
  },
  {
    text: 'Default link text color',
    id: 26,
    value: '{{ AccountPreference.email_color_text_link }}',
  },
  {
    text: 'Default button background color',
    id: 27,
    value: '{{ AccountPreference.email_color_button_background }}',
  },
  {
    text: 'Default button text color',
    id: 28,
    value: '{{ AccountPreference.email_color_button_text }}',
  },
  {
    text: 'Default email font',
    id: 29,
    value: '{{ AccountPreference.email_font }}',
  },
  {
    text: 'Default black logo on light background color',
    id: 30,
    value: '{{ AccountPreference.company_logo_bgcolor_blackonwhite }}',
  },
  {
    text: 'Default color logo background coolor',
    id: 31,
    value: '{{ AccountPreference.company_logo_bgcolor_color }}',
  },
  {
    text: 'Default white logo on dark background color',
    id: 32,
    value: '{{ AccountPreference.company_logo_bgcolor_whiteonblack }}',
  },
  {
    text: 'Default email footer logo background color',
    id: 33,
    value: '{{ AccountPreference.company_logo_bgcolor_email_footer }}',
  },
]

const createInsertTextTool = () =>
  connect(
    state => ({
      customAttributes: state.contacts.customAttributes
        .filter(el => el.name)
        .map((el, idx) => ({
          text: `Contact's ${el.name}`,
          value: `{{ Contact.${el.name} }}`,
          id: idx + 12,
        })),
    }),
    dispatch => bindActionCreators({ paste }, dispatch),
  )(props => {
    const { view, paste, customAttributes } = props

    return (
      <DropDownList
        data={[...mergeFields, ...customAttributes, ...userMergeFields]}
        textField="text"
        dataItemKey="id"
        defaultItem={{
          text: 'merge fields...',
          value: '',
          id: 0,
        }}
        value={{
          text: 'merge fields...',
          value: '',
          id: 0,
        }}
        onChange={event => {
          const mergeField = event.value.value
          if (mergeField !== '') {
            paste(mergeField)
            EditorUtils.insertNode(view, view.state.schema.text(mergeField))
          }
        }}
      />
    )
  })

const DefaultValuesButton = connect(null, dispatch =>
  bindActionCreators({ toggleDefaultValuesModal }, dispatch),
)(({ toggleDefaultValuesModal }) => {
  return (
    <Tooltip title="Merge field default values">
      <IconButton
        onClick={() => toggleDefaultValuesModal(true)}
        // color="secondary"
        style={{ padding: 6 }}
      >
        <Settings />
      </IconButton>
    </Tooltip>
  )
})

const InsertTextTool = createInsertTextTool({
  nodeType: 'text',
  text: 'Sample text',
  props: {
    icon: 'change-manually',
    title: 'Insert Text',
  },
})

export { InsertTextTool, DefaultValuesButton }
